// extracted by mini-css-extract-plugin
export default {"wrapper":"zx-z","button":"Ax-z","alternate":"Bx-z","disabled":"Cx-z","paymentWarning":"Dx-z","fadeIn":"Ex-z"};